const interactiveElements = /* @__PURE__ */ new Set(["INPUT", "TEXTAREA", "SELECT", "OPTION", "BUTTON"]);
const shouldCancelStart = (event) => {
  if (!(event.target instanceof Element)) {
    return true;
  }
  let el = event.target;
  while (el) {
    if (el instanceof Element) {
      if (interactiveElements.has(el.tagName)) {
        return true;
      }
      if (el.sortableHandle === true) {
        return false;
      }
      if (el.getAttribute("data-slate-void") === "true") {
        return false;
      }
      if (el instanceof HTMLElement && el.contentEditable === "true") {
        return true;
      }
    }
    el = el.parentNode;
  }
  return false;
};
export {
  shouldCancelStart
};
//# sourceMappingURL=shouldCancelStart.js.map
